import { useMemo, useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import useStyles from '../index.styles';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import {
  agentSocket,
  chatConnectionId,
  isAgentAvailable,
  setChatConnectionId,
  setShowLiveChat,
} from 'store/reducer/customerReducer';

const ChatHeader = ({ startTime }: { startTime: Date | null }) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const socket = useAppSelector(agentSocket);
  const agentAvailable = useAppSelector(isAgentAvailable);
  const connectionId = useAppSelector(chatConnectionId);

  const [chatDuration, setChatDuration] = useState('00:00:00');

  useEffect(() => {
    const calculateDuration = setInterval(() => {
      if (startTime) {
        const duration = moment.duration(moment(new Date()).diff(startTime));
        const formattedDuration = moment
          .utc(duration.asMilliseconds())
          .format('HH:mm:ss');
        setChatDuration(formattedDuration);
      }
    }, 1000);

    return () => clearInterval(calculateDuration);
  }, [startTime]);

  const chatStartedTime = useMemo(
    () => (startTime ? moment(startTime).format('hh:mm A') : '-'),
    [startTime]
  );

  return (
    <Box className={classes.chatHeader}>
      <Box className={classes.flexBetween}>
        <Typography>ID: {connectionId || `{id}`}</Typography>
        <Box
          className={classes.endChatBtn}
          onClick={() => {
            dispatch(setShowLiveChat(false));
            console.log(
              '🚀 ~ file: index.tsx:53 ~ ChatHeader ~ socket:',
              socket
            );
            console.log(
              '🚀 ~ file: index.tsx:53 ~ ChatHeader ~ agentAvailable:',
              agentAvailable
            );
            if (socket && !agentAvailable) {
              console.log('yes this condition meets');
              socket.close();
              dispatch(setChatConnectionId(''));
            }
          }}
        >
          <IoMdClose color='#D73D00' />
          <Typography>End Chat</Typography>
        </Box>
      </Box>

      <Box className={classes.flexBetween} mt='0.6rem'>
        <Typography>Chat Started at: {chatStartedTime}</Typography>
        <Box>
          <Typography>
            Chat Duration:{' '}
            <Box component='span' sx={{ fontWeight: 600 }}>
              {chatDuration}
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatHeader;
